// extracted by mini-css-extract-plugin
export default {"wideFormat":"ImportResultsModal_wideFormat__UJHsb"};